






















import { Component, Vue } from "vue-property-decorator";
import DadosNome from "@/components/dados/DadosNome.vue";
import DadosEmail from "@/components/dados/DadosEmail.vue";
import DadosDdd from "@/components/dados/DadosDdd.vue";
import DadosTelefone from "@/components/dados/DadosTelefone.vue";
import DadosMarca from "@/components/dados/DadosMarca.vue";
import DadosModelo from "@/components/dados/DadosModelo.vue";
import DadosAno from "@/components/dados/DadosAno.vue";
import DadosProsseguir from "@/components/dados/DadosProsseguir.vue";
import DadosVeiculo from "@/components/dados/DadosVeiculo.vue";

@Component({
    components: {
        DadosVeiculo,
        DadosProsseguir,
        DadosAno,
        DadosModelo,
        DadosMarca,
        DadosTelefone,
        DadosDdd,
        DadosNome,
        DadosEmail
    }
})
export default class Dados extends Vue {

    public mounted () {
        this.$store.commit('SET_SIDEBAR_SHOWING', false);
        this.$store.commit('SET_SIDEBAR_ENABLED', false);

        const query = this.$route.query as {ref: string, fipe: string, ano: string};
        if ( query.fipe !== undefined && query.ano !== undefined ) {
            this.$store.dispatch('FROM_COD_ANO', query).then();
        }
    }

    get origemFipe () {
        return this.$store.state.origem_fipe;
    }

}
